<i [class]="this.iconClass"></i>
